import _ from 'lodash'

export function bindFunctions(functionNames, context) {
	_.forEach(functionNames, functionName => {
		context[functionName] = context[functionName].bind(context)
	})
}



// WEBPACK FOOTER //
// ./src/lib/componentUtils.js